module.exports = __webpack_public_path__ + "img/ic_logo_alibaba@2x.5a826216.png";